export { cloneOrder } from './clone-order.service';
export { createReturnLabelExternallyFulfilled } from './create-return-label-externally-fulfilled.service';
export { createReturnLabelFromTransaction } from './create-return-label-from-transaction.service';
export { createReturnLabelOutbound } from './create-return-label-outbound.service';
export { getOrderStatus } from './get-order-status.service';
export { getOrders } from './get-orders.service';

export { removeOrdersTags } from './remove-orders-tags.service';
export { updateOrdersTags } from './update-orders-tags.service';
/**
 * Service for orders using the Orders MicroService.
 */
export const WEB_ORDERS_API = '/web_orders';
